import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

import { BottomTrayComponent } from '../bottom-tray/bottom-tray.component';
import { RoutePaths } from '../shared/constants/route-paths.constant';
import { LocalStorageService } from '../shared/services/local-storage.service';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { BaseRouteGuard } from './base.route-guard';

@Injectable({
    providedIn: 'root'
})
export class HomeRouteGuard extends BaseRouteGuard implements CanActivate {

    constructor(
        router: Router,
        capabilitiesService: CapabilitiesService,
        private readonly localStorageService: LocalStorageService
    ) {
        super(router, capabilitiesService);
    }

    public canActivate(route: ActivatedRouteSnapshot) {
        const lastTab = this.capabilitiesService.capabilities.bottomTrayEnabled ? this.getStickyTab() : undefined;
        return lastTab ? this.checkEnabledAndRedirect(lastTab === RoutePaths.OfficeHomeFallback, lastTab, route.queryParams) : this.checkEnabledAndRedirect(true);
    }

    private getStickyTab(): RoutePaths | undefined {
        return !this.router.navigated ? this.localStorageService.get(BottomTrayComponent.LastBottomTrayTab) : undefined;
    }
}
